import { render, staticRenderFns } from "./Spaces.vue?vue&type=template&id=71af9971"
import script from "./Spaces.vue?vue&type=script&lang=ts"
export * from "./Spaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports